import React from 'react'

import { useModal } from 'src/shared/components/common/modal'

import { LocaleSelectorButton } from './LocaleSelectorButton'
import { LocaleSelectorModal } from './LocaleSelectorModal'
import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'
import { useThemeColorScheme } from '../default_template/meta/useTheme'
import { DEFAULT_COLORS } from '@toasttab/sites-components'

/**
 * LocaleSelector component provides a locale/language selection interface.
 *
 * Renders a button that opens a modal containing locale selection options.
 * A cookie is set to track the selected locale that is used to intialise i18next with the correct locale.
 *
 * @returns A button that triggers a locale selection modal
 */
export function LocaleSelector() {
  const { restaurant } = useRestaurant()
  const getColorFromTheme = useThemeColorScheme()
  const iconColor = getColorFromTheme((theme) => {
    return (
      theme.colorOverrides?.navigation?.text ?? theme.colorScheme.icon.default
    )
  }, restaurant?.content?.navConfig?.textColor || restaurant?.meta?.textColor || DEFAULT_COLORS.text)
  const { isOpen, onClose, onOpen } = useModal()

  return (
    <>
      <LocaleSelectorButton onClick={onOpen} iconColor={iconColor} />
      <LocaleSelectorModal isOpen={isOpen} onClose={onClose} />
    </>
  )
}
